import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import styles from './styles.module.css';
import ButtonItem from 'components/inputs/ButtonItem';

const ButtonList = (props) => {
  const {
    arrangementClassName,
    classname,
    disabled,
    error,
    idPrefix,
    inline,
    label,
    labelClassName,
    name,
    onChange,
    options,
    type,
    value,
    testIdPrefix,
  } = props;

  const id = `${idPrefix}-ButtonList-Container`;

  const handleChange = (e) => {
    const { value: clicked } = e.target;

    let newValue = [...value];
    switch (type) {
      case 'checkbox':
        const index = value.findIndex((sv) => {
          return (
            sv === clicked || sv === parseInt(clicked, 10) || sv.id === clicked
          );
        });
        if (index === -1) {
          newValue.push(clicked);
        } else {
          newValue.splice(index, 1);
        }
        break;
      default:
        newValue = clicked;
        break;
    }

    const newEvent = Object.assign(
      {},
      {
        target: {
          id,
          name,
          value: newValue,
        },
      },
    );
    onChange(newEvent);
  };

  const isChecked = (optionValue) => {
    return (
      value &&
      optionValue &&
      (value === optionValue ||
        (Array.isArray(value) && value.includes(optionValue)) ||
        value === parseInt(optionValue, 10) ||
        (Array.isArray(value) && value.includes(parseInt(optionValue, 10))) ||
        (Array.isArray(value) && value.some((sv) => sv.id === optionValue)))
    );
  };

  return (
    <Col>
      <Row className={styles.title}>{label}</Row>
      <Row>
        <Col id={id} className={arrangementClassName}>
          {options.map((option, index) => {
            return (
              <ButtonItem
                key={index}
                value={option.value}
                idPrefix={`${idPrefix}${index}`}
                name={name}
                label={option.name}
                onChange={handleChange}
                type={type}
                error={error}
                disabled={disabled}
                isChecked={isChecked(option.value)}
                inline={inline}
                classname={classname}
                labelClassName={labelClassName}
                data-cy-id={`${testIdPrefix}-${option.value}Input`}
              />
            );
          })}
        </Col>
      </Row>
    </Col>
  );
};

ButtonList.propTypes = {
  arrangementClassName: PropTypes.string,
  classname: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  idPrefix: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
};

export default ButtonList;
